exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/_wks-ext.js
// module id = 140
// module chunks = 0